import type { LoginMethod, SalonRow, SalonStage, SignupSource } from '@manaro/contracts'
import type { BadgeTone } from '@/shared/ui/badge.tsx'

export const STAGE_LABELS: Record<SalonStage, string> = {
  registered: 'Без салона',
  salon: 'Нет услуг',
  services: 'Нет клиентов',
  customers: 'Нет записей',
  bookings: 'Ведёт записи',
  paying: 'Платит',
}

export const STAGE_TONES: Record<SalonStage, BadgeTone> = {
  registered: 'neutral',
  salon: 'warn',
  services: 'warn',
  customers: 'info',
  bookings: 'brand',
  paying: 'brand',
}

export const LOGIN_LABELS: Record<LoginMethod, string> = {
  email: 'Email',
  google: 'Google',
  apple: 'Apple',
  facebook: 'Facebook',
}

export const NO_SIGNUP_CHANNEL = 'none'

export const CHANNEL_ORDER = [
  'paid_search',
  'paid_social',
  'organic_search',
  'organic_social',
  'ai',
  'email',
  'referral',
  'direct',
  'unknown',
  NO_SIGNUP_CHANNEL,
]

const CHANNEL_LABELS: Record<string, string> = {
  paid_search: 'Реклама в поиске',
  paid_social: 'Реклама в соцсетях',
  organic_search: 'Поиск',
  organic_social: 'Соцсети',
  ai: 'ИИ-ассистенты',
  email: 'Рассылка',
  referral: 'Переход с сайта',
  direct: 'Прямой заход',
  unknown: 'Неизвестно',
  [NO_SIGNUP_CHANNEL]: 'Нет данных',
}

const CLIENT_LABELS: Record<string, string> = {
  crm: 'CRM',
  site: 'Сайт',
  booking: 'Онлайн-запись',
  ios: 'iOS',
  android: 'Android',
  unknown: 'Неизвестно',
}

const PLAN_LABELS: Record<string, string> = {
  free: 'Бесплатный',
  solo: 'Solo',
  start: 'Start',
  pro: 'Pro',
  network: 'Network',
}

const STATUS_LABELS: Record<string, string> = {
  moderation: 'на модерации',
  active: 'активен',
}

export const planLabel = (plan: string): string => PLAN_LABELS[plan] ?? plan

export const statusLabel = (status: string): string => STATUS_LABELS[status] ?? status

export const bookingPageUrl = (salon: { id: number; slug: string | null }): string =>
  `https://booking.manaro.io/${salon.slug || salon.id}`

export const channelLabel = (channel: string): string => CHANNEL_LABELS[channel] ?? channel

export const clientLabel = (client: string): string => CLIENT_LABELS[client] ?? client

export const signupDetails = (signup: SignupSource): string =>
  [signup.source, signup.campaign].filter(Boolean).join(' · ')

export const SIGNUP_TRACKING_SINCE = '7 октября 2026'

// До начала отслеживания источник не сохранялся. Тогда в CRM не было входа через Google и Apple,
// и только CRM передавала имя при регистрации — остальные подставляли часть почты до @.
export function estimatedClient(user: SalonRow['user']): string {
  if (user.login !== 'email') return 'Приложение или сайт'
  return user.name && user.name !== user.email.split('@')[0] ? 'Скорее CRM' : 'Сайт или приложение'
}
